/**
 * Seo component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';


function Seo({
  description = '',
  lang = 'it',
  meta,
  title,
  siteMetadata,
  landingData,
  links,
}) {
  const {
    description: configDescription, title: titleMetadata, tagline
  } = siteMetadata || {};
  const { socialFacebook } = landingData || {};

  const metaDescription = description || configDescription;
  const titolo = title || `${titleMetadata} - ${tagline}`;

  return (
    <Helmet
      htmlAttributes={{ lang }}
      title={titolo}
      titleTemplate={title ? `%s - ${titleMetadata}` : ''}
      meta={[{
        name: 'description',
        content: metaDescription,
      }, {
        property: 'og:title',
        content: titolo,
      }, {
        property: 'og:description',
        content: metaDescription,
      }, {
        property: 'og:type',
        content: 'website',
      }, {
        property: 'og:image',
        content: socialFacebook?.url,
      }].concat(meta || [])}
    >
      {links?.map((props, k) => (<link {...props} key={`link_${k}`} />))}
    </Helmet>
  );
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
};

export default Seo;
